// Pilot promo code helpers shared by ChatPage (code typed or scanned into chat) and
// ChatLayout (redeeming it once the visitor has logged in and finished their profile).
// The code itself lives only on the backend (PILOT_PROMO_CODE); this file only knows
// what a code looks like, so ordinary chat messages never wait on a promo check.

const PENDING_PROMO_CODE_KEY = 'dash_pending_promo_code';

// One token, 6-32 letters/digits/dashes, with a letter and a digit or dash in it —
// "CARFIDO-PILOT50" or "CFJAX5O-X7K9P2", never "hello" or "yes".
const PROMO_CODE_SHAPE = /^(?=.*[A-Za-z])(?=.*[\d-])[A-Za-z0-9-]{6,32}$/;

export function looksLikePromoCode(text) {
    return PROMO_CODE_SHAPE.test(String(text || '').trim());
}

export function getPendingPromoCode() {
    try {
        return localStorage.getItem(PENDING_PROMO_CODE_KEY) || '';
    } catch {
        return '';
    }
}

export function setPendingPromoCode(code) {
    try {
        localStorage.setItem(PENDING_PROMO_CODE_KEY, String(code || '').trim());
    } catch { /* storage unavailable: the user can send the code again after login */ }
}

export function clearPendingPromoCode() {
    try {
        localStorage.removeItem(PENDING_PROMO_CODE_KEY);
    } catch { /* ignore */ }
}

// CarFido's reply for each /api/promo/redeem status.
export function promoReplyText(result) {
    const offer = result?.offer || {};
    const title = offer.title || 'reward';

    switch (result?.status) {
        case 'login_required':
            return `Create a CarFido account to activate your ${title}. Your offer is not active yet. `
                + 'Complete verification and your driver profile to create your account; then I\'ll activate '
                + 'the offer and save it in Glove Box → Documents. Already have an account? Log in to continue.';
        case 'activated':
            return 'Your $50 offer is active!'
                + `\n\nYour ${title} is saved in Glove Box → Documents. `
                + 'You receive the reward after completing a qualifying service.';
        case 'already_redeemed':
            return `You've already activated this offer. It can be used only once per account, and your ${title} `
                + 'is in Glove Box → Documents.';
        case 'contact_used':
            return 'This offer has already been claimed with this phone number or email, so it can\'t be activated again.';
        case 'expired':
            return `This promo code has expired${offer.expires_label ? ` — the offer ended on ${offer.expires_label}` : ''}.`;
        case 'profile_incomplete':
            return 'Finish your driver profile (name, phone, email and ZIP code), then send the code again to activate this offer.';
        default:
            return '';
    }
}
